import { MutableRefObject, useContext, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { isVarNotEmpty } from '../../NonReact/utils/GlobalFunctions'
import { ALL_VALUE, getTelephonyServer } from '../../React/Common/API/ItemsGetters'
import { IndividualTelItem, ReactState } from '../../React/Common/Types/Types'
import { ReportingAccessLevels } from '../../NonReact/constants/Permissions'
import { displayError } from '../../React/Common/Utils/Messages'
import { UserInfoContextType } from '../../React/Common/Contexts/UserInfoContext'
import { UserInfoContext } from '../../React/Common/Contexts'
import { JSONResponse } from '../../NonReact/common/Types/Types'

export const useCheckUserHasTelsysOfLicence = (licence: ReportingAccessLevels): Definable<boolean> => {
    const userInfo: UserInfoContextType = useContext(UserInfoContext)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const [areUserTelsysCorrectLicence, setAreUserTelsysCorrectLicence]: ReactState<Definable<boolean>> =
        useState<Definable<boolean>>(false)

    useEffect((): void => {
        if (isVarNotEmpty(userInfo)) {
            Promise.all(
                userInfo?.Scope?.TelSysID?.map((telSysID: number): Promise<boolean> => {
                    if (telSysID === ALL_VALUE) {
                        return Promise.resolve(true)
                    }

                    return getTelephonyServer(telSysID).then(
                        (telSys: JSONResponse<IndividualTelItem>): boolean =>
                            !!telSys?.PartitionLicences?.every(
                                (partitionLicence: string): boolean => partitionLicence === licence
                            )
                    )
                })
            )
                .then((telSysAreLicenceMatch: boolean[]): void => {
                    if (isMounted.current) {
                        setAreUserTelsysCorrectLicence(
                            telSysAreLicenceMatch.some((isLicenceMatch: boolean): boolean => isLicenceMatch)
                        )
                    }
                })
                .catch(displayError)
        }
    }, [userInfo])

    return areUserTelsysCorrectLicence
}
